RA.LatestQuestions = {
  init() {
    let url;

    url = Config.contextPath + "/controller/socialsearch/latest/";
    $.get(url)
      .done(this.latestQuestionsDone)
      .fail(RA.handleAjaxError);
  },
  latestQuestionsDone(r) {
    let component;

    if (r.results.length) {
      component = (
        <CommResultsList showIcon={false}
          hits={r.results} />
      )
    } else {
      component = (
        <NoContent message={Labels.getLabel("No recent questions")}>
          <p>
            <a href={Config.contextPath + "/controller/post/discussion/"}>
              {Labels.getLabel("Post your question")}</a>
          </p>
        </NoContent>
      );
    }

    ReactDOM.render(component, document.getElementById("latestQuestions"));
  }
}